module.exports = __webpack_public_path__ + "static/img/8.ccffe70.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/3/sp/8.png
// module id = cTZK
// module chunks = 0